(() => {
  const mobile = window.matchMedia('(max-width:999px)');
  const descriptions = new Map();

  const render = (element, state) => {
    const short = state.copy.scrollHeight <= 240;
    const expanded = !mobile.matches || short || state.mobileExpanded;
    element.dataset.expanded = String(expanded);
    element.toggleAttribute('data-short', short);
    state.button.hidden = !mobile.matches || short;
    state.button.setAttribute('aria-expanded', String(expanded));
    state.label.textContent = expanded ? state.label.dataset.viewLess : state.label.dataset.viewMore;
    state.icon.textContent = expanded ? '−' : '+';
  };

  const mount = () => {
    descriptions.forEach((state, element) => {
      if (!element.isConnected) {
        state.observer?.disconnect();
        descriptions.delete(element);
      }
    });
    document.querySelectorAll('[data-product-description]').forEach(element => {
      if (descriptions.has(element)) return;
      const state = {
        copy: element.querySelector('[data-description-copy]'),
        button: element.querySelector('[data-description-toggle]'),
        label: element.querySelector('[data-description-label]'),
        icon: element.querySelector('.em-product-description__icon'),
        mobileExpanded: false
      };
      descriptions.set(element, state);
      state.button.addEventListener('click', () => {
        if (!mobile.matches) return;
        state.mobileExpanded = !state.mobileExpanded;
        render(element, state);
      });
      if ('ResizeObserver' in window) {
        state.observer = new ResizeObserver(() => render(element, state));
        state.observer.observe(state.copy);
      }
      render(element, state);
    });
  };

  mobile.addEventListener('change', () => {
    descriptions.forEach((state, element) => {
      state.mobileExpanded = false;
      render(element, state);
    });
  });
  mount();
  document.addEventListener('shopify:section:load', mount);
})();
